const MAX_KEY_WORDS = 'max_key_words'
const MIN_KEY_WORDS = 'min_key_words'
const ML_EXPIRATION = 'ml_expiration'
const MIN_KEY_WORDS_WITH_SUBDOMAIN = 'min_key_words_with_subdomain'
const SUBDOMAIN_COUNT = 'subdomain_count'
const SUBDOMAIN_EXPIRATION = 'subdomain_expiration'
const MIN_SUBDOMAIN_LENGTH = 'min_subdomain_length'
const MAX_SUBDOMAIN_LENGTH = 'max_subdomain_length'

export class UserLimits {
    constructor (data) {
        this.limits = data
    }

    getMlExpiration () {
        return this.limits[ML_EXPIRATION]
    }

    getMinMlKeyWords () {
        return this.limits[MIN_KEY_WORDS]
    }

    getMinMlKeyWordsWithSubdomain () {
        return this.limits[MIN_KEY_WORDS_WITH_SUBDOMAIN]
    }

    getMaxMlKeyWords () {
        return this.limits[MAX_KEY_WORDS]
    }

    getSubdomainCount () {
        return this.limits[SUBDOMAIN_COUNT]
    }

    getSubdomainExpiration () {
        return this.limits[SUBDOMAIN_EXPIRATION]
    }

    getSubdomainMinLength () {
        return this.limits[MIN_SUBDOMAIN_LENGTH]
    }

    getSubdomainMaxLength () {
        return this.limits[MAX_SUBDOMAIN_LENGTH]
    }
}
